export const OPEN_CONVERSATION = 'open_conversation';
export const REACTIONS_LOADED = 'reaction_loaded';
